import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Routes, Route } from 'react-router-dom';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import CatalogView from './CatalogView';
import IntegrationDetail from './IntegrationDetail';
import InstallationPage from './InstallationPage';
import CollectorConfigurations from './CollectorConfigurations';

const Marketplace = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTab = () => {
    if (location.pathname.includes('/marketplace/configurations')) return 'Collector configurations';
    if (location.pathname.includes('/marketplace/installed')) return 'Installed integrations';
    return 'Catalog';
  };

  const [activeTab, setActiveTab] = useState<'Catalog' | 'Installed integrations' | 'Collector configurations'>(getActiveTab());

  useEffect(() => {
    setActiveTab(getActiveTab());
  }, [location.pathname]);

  const handleTabChange = (tab: 'Catalog' | 'Installed integrations' | 'Collector configurations') => {
    setActiveTab(tab);
    if (tab === 'Catalog') {
      navigate('/marketplace');
    } else if (tab === 'Installed integrations') {
      navigate('/marketplace/installed');
    } else if (tab === 'Collector configurations') {
      navigate('/marketplace/configurations');
    }
  };

  // Determine if we should show tabs (not on detail pages)
  const showTabs = !location.pathname.includes('/integration/');

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 min-h-screen" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header title="Marketplace" dropdown={2} showBackButton={true} />

        <Card className="flex-1" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <>
            {showTabs && (
              <div className="flex items-center justify-between mb-4 px-6 pt-4">
                <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                  {/* Only show Catalog and Collector configurations tabs for now */}
                  {['Catalog', 'Collector configurations'].map((tab) => (
                    <button
                      key={tab}
                      onClick={() => handleTabChange(tab as any)}
                      style={{
                        padding: '0.5rem 1rem',
                        borderRadius: '6px',
                        borderRight: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                        borderLeft: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                        color: '#fff',
                        cursor: 'pointer',
                        backgroundColor: 'transparent',
                        borderTop: 'none',
                        borderBottom: 'none',
                      }}
                    >
                      {tab}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <Routes>
              <Route path="/" element={<CatalogView />} />
              {/* <Route path="/installed" element={<InstalledIntegrations />} /> */}
              <Route path="/configurations" element={<CollectorConfigurations />} />
              <Route path="/integration/:id" element={<IntegrationDetail />} />
              <Route path="/integration/:integrationId/install/:type" element={<InstallationPage />} />
            </Routes>
          </>
        </Card>
      </div>
    </div>
  );
};

// Placeholder for Installed Integrations
const InstalledIntegrations = () => {
  return (
    <div className="p-6">
      <h2 className="text-white text-xl font-semibold mb-6">Installed Integrations</h2>
      <div className="text-center text-gray-400 py-12">
        <p className="text-lg mb-2">No installed integrations yet</p>
        <p className="text-sm">Browse the catalog to find and install integrations.</p>
      </div>
    </div>
  );
};

export default Marketplace;
